import {ParcelCarrier} from './carrier.types.js'

type CarrierLabelCarrier = Pick<ParcelCarrier, 'name' | 'displayName' | 'logo' | 'products' | 'productLabels' | 'defaultLabel'>

/**
 * Some carriers (Intrapost) have a logo and name per combination of parcel options, e.g. 'Brievenbuspakket' or 'Handtekening voor ontvangst, Niet bij buren'.
 * Without options (general screens such as preferences and rates) the carrier's own logo and name are used.
 *
 * @param {CarrierLabelCarrier} carrier
 * @param {string[]} [options] - options of a specific parcel
 *
 * @returns {{logo: string, displayName: string}}
 */
function getCarrierLabel(carrier: CarrierLabelCarrier, options?: string[]): {logo: string, displayName: string} {
    const carrierLabel = {logo: carrier.logo, displayName: carrier.displayName || carrier.name}

    if (!carrier.productLabels || !options) {
        return carrierLabel
    }

    const carrierOptions = options.filter((option) => carrier.products?.[option])
    const combinedProduct = carrierOptions.length ? [...carrierOptions].sort().join(', ') : 'Standaard zending'

    return carrier.productLabels[combinedProduct] || carrier.defaultLabel || carrierLabel
}

export {getCarrierLabel}
